import { Component, OnInit, Input } from '@angular/core';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { FruHttpService } from '../../../../../../services/fru-http.service';

@Component({
  selector: 'app-form-landing-header',
  templateUrl: './form-landing-header.component.html',
  styleUrls: ['./form-landing-header.component.scss']
})
export class FormLandingHeaderComponent implements OnInit {
  officeStatus: OfficeStatus;

  constructor(
    private fruHttp: FruHttpService
  ) { }

  ngOnInit() {
  }

  adDisclosurePopup() {
    this.fruHttp.adDisclosurePopup();
  }

}
